<template>
  <div class="chuKuZuoyeWarp app-container">
    <div class="chuKuZuoyeWarp-body">
      <div>
        <div>
          <!-- 标题 -->
          <div class="detailsTitle">
            <h4>出库计划</h4>
          </div>
          <!-- 查询条件 -->
          <div ref="searchBox">
            <div class="formBox margbot">
              <el-form :inline="true" :model="formInline" class="demo-form-inline" label-width="100px">
                 <div class="formItemBox">
                <el-form-item label="出库单号:">
                  <el-input v-model="formInline.outstockNo" size="mini" placeholder="请输入出库单号"></el-input>
                </el-form-item>
                <el-form-item label="创建日期:">
                  <div style="display: flex;">
                  <el-date-picker v-model="formInline.dateStart" size="mini" kehu="date"
                    placeholder="选择日期" type="date" value-format="yyyy-MM-dd 00:00:00"></el-date-picker>-
                  <el-date-picker v-model="formInline.dateEnd" size="mini" kehu="date"
                    placeholder="选择日期" type="date" value-format="yyyy-MM-dd 23:59:59"></el-date-picker>
                  </div>
                </el-form-item>
                <el-form-item label="一级货主:">
                  <el-select v-model="formInline.primaryCustomerTaxId" size="mini" filterable clearable
                    placeholder="请选择一级货主">
                    <el-option v-for="(item,index) in OwnerData" :key="index" :label="item.custerName"
                      :value="item.taxpayerNumber">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="二级货主:">
                  <el-select v-model="formInline.customerTaxId" size="mini" filterable clearable placeholder="请选择二级货主">
                    <el-option v-for="(item,index) in OwnerData" :key="index" :label="item.custerName"
                      :value="item.taxpayerNumber">
                    </el-option>
                  </el-select>
                </el-form-item>
                <!-- <el-form-item label="货权方:">
                  <el-select
                    v-model="formInline.ownerCustomerTaxId"
                    size="mini"
                    filterable
                    clearable
                    placeholder="请选择货权方">
                      <el-option
                        v-for="(item,index) in HQData"
                        :key="index"
                        :label="item.custerName"
                        :value="item.taxpayerNumber"
                      >
                    </el-option>
                  </el-select>
                </el-form-item> -->
                <el-form-item label="车牌号:">
                  <el-input v-model="formInline.outstockPlateNumber" maxlength="100" size="mini" placeholder="请输入车牌号">
                  </el-input>
                </el-form-item>
                <!-- <el-form-item label="货物类型:">
                  <el-select
                    v-model="formInline.productType"
                    size="mini"
                    filterable
                    clearable
                    placeholder="请选择货物类型">
                      <el-option
                        v-for="(item,index) in huowuData"
                        :key="index"
                        :label="item.show_name"
                        :value="item.item_no"
                      >
                      </el-option>
                  </el-select>
                </el-form-item> -->
                <el-form-item label="提货单号:">
                  <el-input v-model="formInline.billNo" maxlength="100" size="mini" placeholder="请输入提货单号"></el-input>
                </el-form-item>
                <el-form-item label="外部单号:" >
                  <el-input v-model="formInline.outBillNo" maxlength="50" placeholder="请输入外部单号" size="mini"></el-input>
                </el-form-item>
                </div>
                <el-form-item style="margin-bottom: 0;">
                  <el-button type="primary" size="mini" @click="chaxun" btnCode="003P01DB001" v-if="btnFlg[0]">查询
                  </el-button>
                  <el-button type="primary" size="mini" @click="chongZhi" btnCode="003P01DB002" v-if="btnFlg[1]">重置
                  </el-button>
                  <el-button type="primary" size="mini" @click="addBtn" btnCode="003P01DB003" v-if="btnFlg[2]">新增
                  </el-button>
                  <el-button type="primary" size="mini" @click="deleteBtn" btnCode="003P01DB004" v-if="btnFlg[3]">删除
                  </el-button>
                  <el-button type="primary" size="mini" @click="xiugaiBtn" btnCode="003P01DB005" v-if="btnFlg[4]">修改
                  </el-button>
                  <el-button type="primary" size="mini" @click="daYinBtn" btnCode="003P01DB006" v-if="btnFlg[5]">打印
                  </el-button>
                  <el-button type="primary" size="mini" @click="fangcheBtn" btnCode="003P01DB00E" v-if="btnFlg[13]">放车
                  </el-button>
                  <el-button type="primary" size="mini" @click="queRenChuku" btnCode="003P01DB007" v-if="btnFlg[6]">确认出库
                  </el-button>
                  <el-button type="primary" size="mini" @click="daYinBtn1" btnCode="003P01DB00G" v-if="btnFlg[15]">打印
                  </el-button>
                  <el-button type="primary" size="mini" @click="queRenChuku1" btnCode="003P01DB00F" v-if="btnFlg[14]">
                    确认出库</el-button>
                  <el-button type="primary" size="mini" @click="queRenChuku3" btnCode="003P01DB00K" v-if="btnFlg[19]">
                    确认出库</el-button>
                  <el-button type="primary" size="mini" @click="queRenChuku4" btnCode="003P01DB00J" v-if="btnFlg[18]">
                    确认出库</el-button>
                    <!-- 20240129 念头西库 -->
                  <el-button type="primary" size="mini" @click="queRenChuku5" btnCode="003M2U0300" v-if="btnFlg[23]">
                    确认出库</el-button>
                </el-form-item>

              </el-form>
            </div>
          </div>
          <!--表格-->
          <div :style="{height:h}">
            <el-table height="100%" size="mini" ref="table1" border center bordersize="mini" :data="chukuTableData"
              style="width:100%" class="elTab" :header-cell-style="{background:'#F5F5F5',color:'black'}"
              @row-click="dianjixuanzhong" highlight-current-row>
              <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
              <el-table-column label="操作" align="center" width="100">
                <template slot-scope="scope">
                  <div v-if='scope.row.source == 0'>
                    <!-- <span v-if="scope.row.productType=='4'||scope.row.productType=='5'||scope.row.productType=='6'">
                    <el-button
                      type="text"
                      size="small"
                      @click="addProductTypeClick(scope.row)"
                      btnCode="003P005B008"
                      v-if="btnFlg[7]"
                    >添加货物</el-button>
                  </span> -->
                    <!-- <span
                    v-else-if="scope.row.productType=='1'||scope.row.productType=='2'||scope.row.productType=='3'"
                  > -->
                    <el-button type="text" @click="guanLianClick(scope.row)" btnCode="003P01DB00D" v-if="btnFlg[12]">
                      关联货物</el-button>
                    <el-button type="text" @click="guanLianClickTwo(scope.row)" btnCode="003P01DB00I" v-if="btnFlg[17]">
                      关联货物</el-button>
                      <!-- 念头西库20240126 -->
                    <el-button type="text" @click="guanLianClickTwo1(scope.row)"  v-if="btnFlg[21]">
                      关联货物</el-button>
                    <!-- </span> -->
                  </div>

                </template>
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="outstockNo" label="出库单号" align="center" width="250">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="carHoldFalg" label="是否扣车" align="center" width="150">
                <template v-slot="scpoed">
                  <span v-if="scpoed.row.carHoldFalg==0" style="color:green">不扣车</span>
                  <span v-else style="color:red">扣车</span>
                </template>
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="outBillNo" label="外部单号" width="150px">
              </el-table-column>
              <el-table-column prop="primaryCustomerName" label="一级货主" align="center" width="250"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" align="center"
                width="250"></el-table-column>
              <!-- <el-table-column
                :show-overflow-tooltip="true"
                prop="ownerCustomerName"
                label="货权方"
                align="center"
                width="250"
              ></el-table-column> -->

              <el-table-column :show-overflow-tooltip="true" prop="outstockPlateNumber" label="车牌号" align="center"
                width="180"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="driverName" label="司机" align="center" width="200">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="telephone" label="司机电话" align="center" width="200">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="idNumber" label="身份证号" align="center" width="200">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="sourceName" label="数据来源" align="center" width="100">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="billNo" label="提货单号" align="center" width="220">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="createUser" label="创建人" align="center" width="200">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="createTime" label="创建时间" align="center" width="180"
                :formatter="dateTimeFormat"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="printDate" label="打印时间" align="center" width="180"
                :formatter="dateTimeFormat"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="remark" label="备注" align="center">
                <template v-slot="scope">
                  <div>
                    <el-button size="small" type="text" @click="chakanbeizhu(scope.row)">查看</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!--分页-->
          <div class="pags" style="text-align: right;">
            <el-pagination background @current-change="handleCurrentChangeA" :current-page="formInline.pageNo"
              :page-size="formInline.pageSize" :page-sizes="[10, 20, 30, 40,50]"
              layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChangeA" :total="total">
            </el-pagination>
          </div>
          <!--出库单详情-->
          <div>
            <!-- <el-tabs v-model="activeName">
              <el-tab-pane
                label="货物详情"
                name="first"
                v-if="HWXiangQingLook"
              > -->
            <div class="detailsTitle">
              <h4>货物详情</h4>
            </div>

            <!-- </el-tab-pane>
              </el-tabs> -->
            <!-- <el-button
                type="primary"
                size="mini"
                @click="editZhuangche"
                btnCode="003P01DB00A"
                v-if="btnFlg[9]"
              >修改装车确认</el-button> -->
            <!-- <el-button
                type="primary"
                size="mini"
                @click="Addplan"
                btnCode="003P01DB00B"
                v-if="btnFlg[10]"
              >添加净重</el-button>
              <el-button
                type="primary"
                size="mini"
                @click="editplan"
                btnCode="003P01DB00C"
                v-if="btnFlg[11]"
              >修改添加净重</el-button> -->
            <div ref="searchBox2" style="margin-top: 5px;margin-bottom:5px;margin-left:10px;">
              <el-button type="primary" size="mini" @click="deleteDetail" btnCode="003P01DB008" v-if="btnFlg[7]">删除
              </el-button>
              <el-button type="primary" size="mini" @click="zhuangche" btnCode="003P01DB009" v-if="btnFlg[8]">装车确认
              </el-button>
              <el-button type="primary" size="mini" @click="Whzhuangche" btnCode="003P01DB00H" v-if="btnFlg[16]">装车确认
              </el-button>
              <el-button type="primary" size="mini" @click="zhuangcheTwo" btnCode="003P01DB00L" v-if="btnFlg[20]">
                装车确认</el-button>
                <!-- 念头西库20240126 -->
              <el-button type="primary" size="mini" @click="zhuangcheTwo1"  v-if="btnFlg[22]">
                装车确认</el-button>
              <span>
                总吨数:
                <span style="color: red">{{ allWeight }}</span> &nbsp;吨
              </span>
              <span style="margin-left: 20px">
                总件数:
                <span style="color: red">{{ allNumber }}</span> &nbsp;件
              </span>
            </div>
            <!-- <p class="detailsTitle-sum"><span>总吨数：<span class="num">{{allWeight}}</span>吨</span><span style="margin-left:20px;">总件数：<span class="num">{{allNumber}}</span>件</span></p> -->
            <!--详情表格-->
            <div class="ruKuZuoyeWarp-body-detailsTab">
              <div class="ruKuZuoyeWarp-body-table" :style="{height:detailsH}">
                <el-table height="100%" size="mini" ref="table2" :data="subTableData" style="width:100%"
                  highlight-current-row border center bordersize="mini"
                  :header-cell-style="{background:'#F5F5F5',color:'black'}" @row-click="dianjiXiangqingtable"
                  @select="selectXiangqingTable" @selection-change="changeFun">

                  <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center"
                    width="150"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="placeOfOrigin" label="产地" align="center"
                    width="250"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center"
                    width="150"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" align="center" width="150">
                  </el-table-column>
                  <!-- <el-table-column
                    :show-overflow-tooltip="true"
                    prop="root"
                    label="单件支数"
                    align="center"
                    width="150"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="length"
                    label="长度（m）"
                    align="center"
                    width="150"
                  ></el-table-column> -->
                  <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓位" align="center"
                    width="120"></el-table-column>
                    <el-table-column prop="locationName" align="center" label="区位"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center" width="120">
                  </el-table-column>
                  <el-table-column :show-overflow-tooltip="true" label="总重量（吨）" align="center" width="150">
                    <template slot-scope="scope">
                      <div>
                        <span v-if="scope.row.allWeight == undefined || scope.row.allWeight == ''"></span>
                        <span v-else>{{Number(scope.row.allWeight).toFixed(3)}}</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column :show-overflow-tooltip="true" label="理重（吨）" align="center" width="150">
                    <template slot-scope="scope">
                      <div>
                        <span v-if="scope.row.weight == undefined || scope.row.weight == ''"></span>
                        <span v-else>{{Number(scope.row.weight).toFixed(3)}}</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="weighingWeight" label="过磅净重（吨）" align="center"
                    width="150">
                    <template slot-scope="scope">
                      <div>
                        <span v-if="scope.row.weighingWeight == undefined || scope.row.weighingWeight == ''"></span>
                        <span v-else>{{Number(scope.row.weighingWeight).toFixed(3)}}</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="weighingDate" label="过磅时间" align="center"
                    width="200" :formatter="dateTimeFormat"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="sceneUser" label="现场人员" align="center"
                    width="200"></el-table-column>
                </el-table>
                <!-- 分页-->
                <div class="pags" style="text-align: right;">
                  <el-pagination background @current-change="handleCurrentChangeXQ" :current-page="currentXQ"
                    :page-size="pagesizeXQ" :page-sizes="[10,20,30,40,50]"
                    layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChangeXQ" :total="totalXQ">
                  </el-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- dialogs -->
    <!-- 装车确认 -->
    <el-dialog :title="zhuangcheTitle" :visible.sync="zhuangcheDialog" :close-on-click-modal="false"
      @close="zhuangcheClose" center>
      <el-form label-width="150px" ref="zhuangcheForm" class="demo-form-inline" :model="zhuangcheForm"
        :rules="zhuangcheRules" inline>
        <el-form-item label="实出件数" prop="number">
          <el-input style="width:193px;" class="ipt" type="number" size="mini" v-model="zhuangcheForm.number"
            v-number-input.float="0" @blur="NumberInput"></el-input>
        </el-form-item>
        <el-form-item label="理重" prop="weight">
          <el-input style="width:193px;" class="ipt" disabled size="mini" v-model="zhuangcheForm.weight"></el-input>
        </el-form-item>
        <el-form-item label="现场人员" prop="sceneUserId">
          <el-select style="width:193px;" v-model="zhuangcheForm.sceneUserId" size="mini" filterable clearable
            placeholder="请选择现场人员">
            <el-option v-for="(item,index) in xianchangRY" :key="index" :label="item.userName" :value="item.userCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="weighingWeight" label="过磅净重（吨）">
          <el-input v-model="zhuangcheForm.weighingWeight" v-number-input.float="3" size="mini" style="width:193px;"
            :min="0" placeholder="请输入过磅净重"></el-input>
        </el-form-item>
        <el-form-item prop="weighingDate" label="实际过磅时间">
          <el-date-picker style="width:193px;" v-model="zhuangcheForm.weighingDate" size="mini" type="datetime"
            placeholder="选择过磅日期"></el-date-picker>
        </el-form-item>
      </el-form>
      <div style="width:158px;margin:20px auto;">
        <el-button @click="zhuangcheClose">取消</el-button>
        <el-button type="primary" :loading='zhuangcheLoading' @click="zhuangcheOK">保存</el-button>
      </div>
    </el-dialog>
    <!-- 新增出库计划 -->
    <el-drawer direction="ltr" :title="planTitle" :wrapperClosable="false" :visible.sync="planDialog" size="550px">
      <el-form label-width="150px" ref="planForm" class="demo-form-inline" :model="planForm" :rules="planRules">
        <!-- <el-form-item
          prop="ownerCustomerTaxId"
          label="货权方"
         >
          <el-select
            v-model="planForm.ownerCustomerTaxId"
            size="mini"
            filterable
            :disabled="dis"
            style="width:200px;"
            placeholder="请选择货权方"
            clearable
          >
            <el-option
              v-for="(item,index) in OwnerData"
              :key="index"
              :label="item.custerName"
              :value="item.taxpayerNumber"
            >
           </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item prop="primaryCustomerTaxId" label="一级货主">
          <el-select v-model="planForm.primaryCustomerTaxId" size="mini" filterable :disabled="dis" style="width:200px;"
            placeholder="请选择一级货主" clearable>
            <el-option v-for="(item,index) in OwnerData" :key="index" :label="item.custerName"
              :value="item.taxpayerNumber">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="customerTaxId" label="二级货主">
          <el-select v-model="planForm.customerTaxId" size="mini" filterable style="width:200px;" placeholder="请选择二级货主"
            :disabled="dis" clearable>
            <el-option v-for="(item,index) in OwnerData" :key="index" :label="item.custerName"
              :value="item.taxpayerNumber">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item
              prop="productType"
              label="货物类型"
            >
              <el-select
                v-model="planForm.productType"
                size="mini"
                filterable
                :disabled='typeDisabled'
                style="width:200px;"
                clearable
                placeholder="请选择货物类型">
                  <el-option
                    v-for="(item,index) in huowuData"
                    :key="index"
                    :label="item.show_name"
                    :value="item.item_no"
                  >
                </el-option>
              </el-select>
            </el-form-item> -->
        <el-form-item prop="outstockPlateNumber" label="出库车牌号">
          <el-input v-model="planForm.outstockPlateNumber" size="mini" style="width:200px;" placeholder="请输入出库车牌号">
          </el-input>
        </el-form-item>
        <el-form-item prop="driverName" label="司机姓名" :rules="[
              {
                required: false,
                message: '请输入司机姓名',
                trigger: 'change',
              }
              ]">
          <el-input v-model="planForm.driverName" size="mini" style="width:200px;" placeholder="请输入司机姓名"></el-input>
          <el-button style="margin-left:10px;" type="text" @click="selectDriverChange">选择</el-button>
        </el-form-item>
        <el-form-item prop="telephone" label="司机手机">
          <el-input v-model="planForm.telephone" size="mini" style="width:200px;" placeholder="请输入司机手机"
            v-number-input.float="0" :maxlength="11"></el-input>
        </el-form-item>
        <el-form-item prop="idNumber" label="身份证号">
          <el-input v-model="planForm.idNumber" size="mini" style="width:200px;" placeholder="请输身份证号" maxlength="18">
          </el-input>
        </el-form-item>
        <el-form-item prop="billNo" label="提货单号">
          <el-input v-model="planForm.billNo" size="mini" style="width:200px;" placeholder="请输入提货单号" maxlength="32">
          </el-input>
        </el-form-item>
        <el-form-item prop="carHoldFalg" label="是否扣车">
          <el-radio-group v-model="planForm.carHoldFalg" size="small" :disabled="dis">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="remark" label="备注">
          <el-input v-model="planForm.remark" size="mini" style="width:200px;" placeholder="请输入备注" maxlength="100"
            type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div style="width:158px;margin:20px auto;">
        <el-button @click="planClose">取消</el-button>
        <el-button type="primary" :loading="PlanOkLoading" @click="planOK">保存</el-button>
      </div>
      <select-siji v-if="table" :table.sync="table" @selectDriver="selectDriver"></select-siji>
    </el-drawer>
    <!-- 关联货物 -->
    <guan-lian-huo-wu v-if="addProductTypeMark" :addProductTypeMark.sync="addProductTypeMark" :HwType="HwType"
      :GuanlianHuowuRow="GuanlianHuowuRow"></guan-lian-huo-wu>
    <!-- 关联货物 2.0-->
    <guan-lian-huowu-two v-if="addProductTypeTwoMark" :addProductTypeTwoMark.sync="addProductTypeTwoMark"
      :HwType="HwType" :GuanlianHuowuRow="GuanlianHuowuRow"></guan-lian-huowu-two>
    <GuanLianHuowuThree v-if="addProductTypeThreeMark" :addProductTypeThreeMark.sync="addProductTypeThreeMark"
      :HwType="HwType" :GuanlianHuowuRow="GuanlianHuowuRow"></GuanLianHuowuThree>
    <!-- 确认出库 -->
    <el-dialog title="确认出库" :visible.sync="queRenChukuVisible" :close-on-click-modal="false" width="50%"
      @close="closeQuerenchuku" center>
      <el-form ref="querenChukuFormData" label-width="200px" style="width: 500px; margin: 30px auto"
        :model='querenChukuForm'>
        <el-form-item label="车牌号 :" :rules="[
            {
              required: true,
              message: '请先维护本物料单件理重',
              trigger: 'blur',
            },
          ]">
          <span style="width: 200px">{{querenChukuForm.plateNumber}}</span>
        </el-form-item>
        <el-form-item prop="zhuangcheCost" label="装车费(元)：" :rules="[
            {
              required: true,
              message: '请输入装车费',
              trigger: 'blur',
            },
          ]">
          <el-input v-number-input.float="2" v-model="querenChukuForm.zhuangcheCost" size="mini" style="width: 200px"
            placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="closeQuerenchuku">取 消</el-button>
        <el-button type="primary" :loading="querenChukuLoading" @click="querenChukuOk">保 存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="查看备注" :visible.sync="dialogBeizhuVisible" width="35%">
      <div v-if="!lookApproverReject">{{beizhu}}</div>
      <span v-if="lookApproverReject">暂无备注</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogBeizhuVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 乌海装车确认 增加仓库-->
    <el-dialog :title="zhuangcheTitle" :visible.sync="WhzhuangcheDialog" :close-on-click-modal="false"
      @close="WhzhuangcheClose" center>
      <el-form label-width="150px" ref="WhzhuangcheForm" class="demo-form-inline" :model="WhzhuangcheForm"
        :rules="WhzhuangcheRules" inline>
        <el-form-item label="实出件数" prop="number">
          <el-input style="width:193px;" class="ipt" type="number" size="mini" v-model="WhzhuangcheForm.number"
            v-number-input.float="0" @blur="WhNumberInput"></el-input>
        </el-form-item>
        <el-form-item label="理重" prop="weight">
          <el-input style="width:193px;" class="ipt" disabled size="mini" v-model="WhzhuangcheForm.weight"></el-input>
        </el-form-item>
        <el-form-item label="仓位" prop="warehouseId">
          <el-select filterable clearable @change="changeCangWei" v-model="WhzhuangcheForm.warehouseId" size="mini"
            placeholder="请选择仓位" style="width:193px;">
            <el-option v-for="(item,index) in CangweiOptions" :key="index" :label="item.value" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="库存可提件数" prop="keti" v-if="isValid">
          <el-input style="width:193px;" class="ipt" disabled size="mini" v-model="stockAvailableNumber"></el-input>
        </el-form-item>
        <el-form-item label="现场人员" prop="sceneUserId">
          <el-select style="width:193px;" v-model="WhzhuangcheForm.sceneUserId" size="mini" filterable clearable
            placeholder="请选择现场人员">
            <el-option v-for="(item,index) in xianchangRY" :key="index" :label="item.userName" :value="item.userCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="weighingWeight" label="过磅净重（吨）">
          <el-input v-model="WhzhuangcheForm.weighingWeight" v-number-input.float="3" size="mini" style="width:193px;"
            :min="0" placeholder="请输入过磅净重"></el-input>
        </el-form-item>
        <el-form-item prop="weighingDate" label="实际过磅时间">
          <el-date-picker style="width:193px;" v-model="WhzhuangcheForm.weighingDate" size="mini" type="datetime"
            placeholder="选择过磅日期"></el-date-picker>
        </el-form-item>
      </el-form>
      <div style="width:158px;margin:20px auto;">
        <el-button @click="WhzhuangcheClose">取消</el-button>
        <el-button type="primary" :loading='WhzhuangcheLoading' @click="WhzhuangcheOK">保存</el-button>
      </div>
    </el-dialog>

    <!-- 确认装车 -->
    <confirm-delivery v-if="confirmVisible" :confirmVisible.sync='confirmVisible' :outstockId="outstockId"
      :deliveryObj="deliveryObj" :marsterData='marsterData'></confirm-delivery>
    <confirmDeliveryThree v-if="confirmVisibleThree" :confirmVisibleThree.sync='confirmVisibleThree' :outstockId="outstockId"
      :deliveryObj="deliveryObj" :marsterData='marsterData'></confirmDeliveryThree>
    <!-- 20240129 确认出库 -->
    <queRenChuKu v-if="queRenChuKuVisible1" :xuanzhongArr="xuanzhongArr" :queRenChuKuVisible1.sync='queRenChuKuVisible1'></queRenChuKu>

  </div>
</template>

<script>
import {
  getBtn
} from '@/utils/getButton'
import SelectSiji from '../SelectSiji'
import {
  getRelationCustomer, // 字典-客户
  getUsersByTenantCode,
  zidian,
  getWeighingMethodList,
  getTStockSummaryAvailableNumber
  // getDictionaryList
} from '@/api/wms-stock'
import {
  getOutstockMasterList,
  getOutstockSummaryList,
  addWhOutstockMaster,
  updateWhOutstockMasterLwg,
  deleteWhOutstockMaster,
  getWhOutstockMasterLwg,
  confirmWhOutstockLwg,
  confirmWhOutstockZy,
  delTOutstockSummary,
  getTOutstockSummary,
  updateTOutstockSummary,
  getPlgxTStockSummaryGroup
} from '@/api/wms-access'
import confirmDelivery from './confirmDelivery.vue'

import DonMessage from '@/utils/message'
import GuanLianHuoWu from './GuanLianHuoWu.vue'
import GuanLianHuowuTwo from './GuanLianHuowuTwo.vue'
import confirmDeliveryThree from './confirmDeliveryThree.vue'
import GuanLianHuowuThree from './GuanLianHuowuThree.vue'
import queRenChuKu from './queRenChuKu.vue'
import {
  dateTimeFormat
} from '@/utils/util'

export default {
  components: {
    confirmDelivery,
    SelectSiji,
    GuanLianHuoWu,
    GuanLianHuowuTwo,
    confirmDeliveryThree,
    GuanLianHuowuThree,
    queRenChuKu
  },
  name: 'ChukuPlan',
  data () {
    return {
      deliveryObj: {},
      marsterData: {},
      confirmVisible: false,

      dis: false,
      zyFlag: 0,
      activeName: 'first',
      HWXiangQingLook: true,
      dateTimeFormat: dateTimeFormat, // 列表时间格式化
      HwType: true,
      huowuData: [],
      chukuTableData: [],
      formInline: {
        outstockNo: '',
        dateStart: '',
        dateEnd: '',
        primaryCustomerTaxId: '',
        customerTaxId: '',
        outstockPlateNumber: '',
        productType: '',
        billNo: '',
        pageNo: 1,
        pageSize: 20,
        outstockStatus: 0,
        outBillNo: ''
      },
      OwnerData: [],
      HQData: [],
      btnFlg: [],
      btnIdArr: [
        '003P01DB001',
        '003P01DB002',
        '003P01DB003',
        '003P01DB004',
        '003P01DB005',
        '003P01DB006',
        '003P01DB007',
        '003P01DB008',
        '003P01DB009',
        '003P01DB00A',
        '003P01DB00B',
        '003P01DB00C',
        '003P01DB00D',
        '003P01DB00E',
        '003P01DB00F',
        '003P01DB00G',
        '003P01DB00H',
        '003P01DB00I',
        '003P01DB00J',
        '003P01DB00K',
        '003P01DB00L',
        '003M2U0100',
        '003M2U0200',
        '003M2U0300'
      ],

      h: '500px',
      detailsH: '200px',
      total: 0,
      currentXQ: 1,
      pagesizeXQ: 20,
      totalXQ: 0,
      addProductTypeMark: false,
      addProductTypeTwoMark: false,
      // 明细表
      subTableData: [],
      xuanzhongArrXQ: null,
      allWeight: 0,
      allNumber: 0,
      // dialogs
      // 装车
      table: false,
      xianchangRY: [],
      zhuangcheTitle: '',
      zhuangcheForm: {
        sceneUserId: '',
        number: '',
        weight: '',
        weighingWeight: '',
        weighingDate: '',
        warehouseName: '',
        warehouseId: ''
      },
      zhuangcheRules: {
        sceneUserId: [{
          required: true,
          message: '请选择现场人员',
          trigger: 'change'
        }],
        number: [{
          required: true,
          message: '请输入实出件数',
          trigger: 'blur'
        }],
        weighingWeight: [{
          required: true,
          message: '请输入过磅净重',
          trigger: 'blur'
        }],
        weighingDate: [{
          required: true,
          message: '请选择实际过磅时间',
          trigger: 'change'
        }]
      },
      zhuangcheDialog: false,
      zhuangcheLoading: false,
      // 出库计划
      planLoading: false,
      planDialog: false,
      planTitle: '',
      planForm: {
        // ownerCustomerTaxId: '', // 货权方
        // ownerCustomerName: '',
        primaryCustomerTaxId: '',
        customerTaxId: '',
        outstockPlateNumber: '',
        driverName: '',
        telephone: '',
        idNumber: '',
        billNo: '',
        productType: '',
        carHoldFalg: '',
        productTypeName: '',
        remark: ''
      },
      planRules: {
        primaryCustomerTaxId: [{
          required: true,
          message: '请选择一级货主',
          trigger: 'change'
        }],
        customerTaxId: [{
          required: true,
          message: '请选择二级货主',
          trigger: 'change'
        }],
        outstockPlateNumber: [{
          required: true,
          message: '请输入出库车牌号',
          trigger: 'blur'
        },
        this.rule.vhcNo
        ],
        driverName: [{
          required: true,
          message: '请输入司机姓名',
          trigger: 'blur'
        }],
        productType: [{
          required: true,
          message: '请选择货物类型',
          trigger: 'change'
        }],
        carHoldFalg: [{
          required: true,
          message: '请选择是否扣车',
          trigger: 'change'
        }]
      },
      xuanzhongArr: null,
      outstockId: '',
      PlanOkLoading: false,
      GuanlianHuowuRow: {},
      outWeighingMethod: '',
      singletonWeight: '',
      xinzeng: true,
      typeDisabled: false,
      queRenChukuVisible: false,
      querenChukuLoading: false,
      queRenChuKuVisible1: false,
      querenChukuForm: {
        zhuangcheCost: '',
        plateNumber: ''
      },
      beizhu: '',
      dialogBeizhuVisible: false,
      lookApproverReject: false,
      // 乌海
      WhzhuangcheDialog: false,
      WhzhuangcheLoading: false,
      WhzhuangcheForm: {
        sceneUserId: '',
        number: '',
        weight: '',
        weighingWeight: '',
        weighingDate: '',
        warehouseId: '',
        warehouseName: ''
      },
      WhzhuangcheRules: {
        sceneUserId: [{
          required: true,
          message: '请选择现场人员',
          trigger: 'change'
        }],
        number: [{
          required: true,
          message: '请输入实出件数',
          trigger: 'blur'
        }],
        weighingWeight: [{
          required: true,
          message: '请输入过磅净重',
          trigger: 'blur'
        }],
        weighingDate: [{
          required: true,
          message: '请选择实际过磅时间',
          trigger: 'change'
        }],
        warehouseId: [{
          required: true,
          message: '请选择仓位',
          trigger: 'change'
        }]
      },
      CangweiOptions: [],
      stockAvailableNumber: '',
      isValid: false,
      addProductTypeThreeMark: false,
      confirmVisibleThree: false
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/ChukuPlanLwg')
    console.log(this.btnFlg[19], 'this.btnFlg')
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let h2 = this.$refs.searchBox2.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = 0.6 * pH - h - 145 + 'px'
    this.detailsH = 0.4 * pH - h2 - 70 + 'px'
    // this.guanLianH = 0.6 * pH + 'px'

    this.getOutstockMasterLists()
    this.getRelationCustomerS() // 货主
  },
  methods: {
    // ----------------------装车确认
    zhuangcheTwo () {
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
      } else {
        this.confirmVisible = true
        this.deliveryObj = this.subTableData[0]
        this.outstockId = Number(this.xuanzhongArr.outstockId)
        this.marsterData = this.xuanzhongArr
        console.log(this.marsterData, 'this.marsterData')
      }
    },
    zhuangcheTwo1 () {
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
      } else {
        this.confirmVisibleThree = true
        this.deliveryObj = this.subTableData[0]
        this.outstockId = Number(this.xuanzhongArr.outstockId)
        this.marsterData = this.xuanzhongArr
        console.log(this.marsterData, 'this.marsterData')
      }
    },
    // ---------------------------------------
    chakanbeizhu (row) {
      this.dialogBeizhuVisible = true
      this.beizhu = row.remark
    },
    // 确认出库
    querenChukuOk () {
      this.$refs.querenChukuFormData.validate((valid) => {
        if (valid) {
          this.querenChukuLoading = true
          if (this.zyFlag == 1) {
            confirmWhOutstockZy({
              outstockId: this.xuanzhongArr.outstockId,
              loadingFee: this.querenChukuForm.zhuangcheCost
            })
              .then(res => {
                DonMessage.success('操作成功!')
                this.getOutstockMasterLists()
                this.queRenChukuVisible = false
              })
              .catch(err => {
                this.querenChukuLoading = false
                this.$message.error(err.message)
              })
          } else {
            confirmWhOutstockLwg({
              outstockId: this.xuanzhongArr.outstockId,
              loadingFee: this.querenChukuForm.zhuangcheCost
            })
              .then(res => {
                DonMessage.success('操作成功!')
                this.getOutstockMasterLists()
                this.queRenChukuVisible = false
              })
              .catch(err => {
                this.querenChukuLoading = false
                this.$message.error(err.message)
              })
          }
        } else {
          this.querenChukuLoading = false
        }
      })
    },
    closeQuerenchuku () {
      this.queRenChukuVisible = false
    },
    NumberInput () {
      console.log(this.zhuangcheForm.number, this.singletonWeight)
      this.zhuangcheForm.weight = (this.zhuangcheForm.number / 1 * this.singletonWeight / 1).toFixed(3)
    },
    chaxun () {
      this.getOutstockMasterLists()
    },
    chongZhi () {
      this.formInline.outstockNo = ''
      this.formInline.dateStart = ''
      this.formInline.dateEnd = ''
      this.formInline.primaryCustomerTaxId = ''
      this.formInline.customerTaxId = ''
      this.formInline.outstockPlateNumber = ''
      this.formInline.productType = ''
      this.formInline.billNo = ''
      // this.formInline.ownerCustomerTaxId = ''
      this.formInline.outBillNo = ''
      this.formInline.pageNo = 1
      this.getOutstockMasterLists()
    },
    addBtn () {
      this.planDialog = true
      this.PlanOkLoading = false
      this.typeDisabled = false
      this.dis = false

      // this.getDictionaryLists()
      this.planForm.outstockId = ''
      this.planTitle = '新增出库计划'
      this.xinzeng = true
      this.$nextTick(() => {
        this.$refs.planForm.clearValidate()
        this.$refs.planForm.resetFields()
      })
      // this.planForm.primaryCustomerTaxId = ''
      // this.planForm.customerTaxId = ''
      // this.planForm.outstockPlateNumber = ''
      // this.planForm.driverName = ''
      // this.planForm.telephone = ''
      // this.planForm.idNumber = ''
      // this.planForm.billNo = ''
      // this.planForm.productType = ''
      // this.planForm.carHoldFalg = ''
      // this.planForm.outstockId = ''
    },
    deleteBtn () {
      if (this.chukuTableData.length == 0) {
        DonMessage.error('暂无数据')
        return
      }
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
        return
      }
      // if (this.xuanzhongArr.source != 0) {
      //   DonMessage.error('数据来源必须是手动!')
      //   return
      // }
      const that = this
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteWhOutstockMaster({
          outstockId: this.xuanzhongArr.outstockId
        })
          .then(res => {
            DonMessage.success('删除成功')
            that.getOutstockMasterLists()
          })
          .catch(error => {
            DonMessage.error(error)
          })
      })
    },
    xiugaiBtn () {
      if (this.chukuTableData.length == 0) {
        DonMessage.error('暂无数据')
        return
      }
      // if (this.xuanzhongArr.source == 3) {
      //   DonMessage.error('数据来源为货主端，不可修改')
      //   return
      // }

      // if (this.xuanzhongArr.source == 0 && this.subTableData.length > 0) {
      //   this.typeDisabled = true
      // }
      this.planDialog = true
      this.PlanOkLoading = false
      this.dis = true

      this.planTitle = '修改出库计划'
      this.xinzeng = false

      getWhOutstockMasterLwg({
        outstockId: this.xuanzhongArr.outstockId
      })
        .then(res => {
          console.log(res)
          this.planForm.outstockId = res.outstockId
          // this.planForm.huoQuanFang = res.huoQuanFang
          this.planForm.primaryCustomerTaxId = res.primaryCustomerTaxId
          // this.planForm.ownerCustomerTaxId = res.ownerCustomerTaxId
          this.planForm.customerTaxId = res.customerTaxId
          this.planForm.outstockPlateNumber = res.outstockPlateNumber
          this.planForm.driverName = res.driverName
          this.planForm.telephone = res.telephone
          this.planForm.idNumber = res.idNumber
          this.planForm.productType = res.productType
          this.planForm.billNo = res.billNo
          this.planForm.carHoldFalg = res.carHoldFalg
          this.planForm.remark = res.remark
        })
        .catch(err => {
          DonMessage.error(err)
        })

      // this.$refs.planForm.clearValidate()
    },
    // 点击选择司机
    selectDriverChange () {
      // this.sijiChange = true
      this.table = true
    },
    selectDriver (row) {
      console.log(row)
      this.$set(this.planForm, 'driverName', row.name)
      this.$set(this.planForm, 'telephone', row.mobile)
      this.$set(this.planForm, 'idNumber', row.identityNo)
    },
    daYinBtn () {
      if (this.chukuTableData.length == 0) {
        DonMessage.error('暂无数据')
        return
      }
      if (this.chukuTableData.length == 0) {
        this.$message({
          message: '暂无数据',
          type: 'error'
        })
        return
      }
      this.$router.push({ // 核心语句
        path: '/zhuangcheDanPrint', // 跳转的路径
        query: {
          // 路由传参时push和query搭配使用 ，作用时传递参数
          id: this.xuanzhongArr.outstockId
        }
      })
    },
    daYinBtn1 () {
      if (this.chukuTableData.length == 0) {
        DonMessage.error('暂无数据')
        return
      }
      if (this.chukuTableData.length == 0) {
        this.$message({
          message: '暂无数据',
          type: 'error'
        })
        return
      }
      this.$router.push({ // 核心语句
        path: '/zhuangcheDanPrint1', // 跳转的路径
        query: {
          // 路由传参时push和query搭配使用 ，作用时传递参数
          id: this.xuanzhongArr.outstockId
        }
      })
    },
    fangcheBtn () {
      if (this.xuanzhongArr.carHoldFalg == 0) {
        DonMessage.error('该状态不需要放车操作')
        return
      }
      if (this.chukuTableData.length == 0) {
        DonMessage.error('暂无数据')
        return
      }
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
        return
      }
      // if (this.xuanzhongArr.source == 3) {
      //   DonMessage.error('本单为货主下发，请联系货主操作放车')
      //   return
      // }
      this.$confirm('确定放车吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log(this.xuanzhongArr)
        let param = {}
        param.outstockId = this.xuanzhongArr.outstockId
        param.carHoldFalg = '0'
        param.outstockStatus = '0'
        updateWhOutstockMasterLwg(param)
          .then(res => {
            DonMessage.success('成功')
            this.getOutstockMasterLists()
            this.PlanOkLoading = false
            this.planDialog = false
          })
          .catch(err => {
            DonMessage.error(err)
          })
      })
    },
    queRenChuku () {
      this.zyFlag = 0

      if (this.chukuTableData.length == 0) {
        DonMessage.error('暂无数据')
        return
      }
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
        return
      }
      if (this.xuanzhongArr.carHoldFalg == '1') {
        DonMessage.error('请先放行车辆')
        return
      }
      this.queRenChukuVisible = true
      this.querenChukuLoading = false
      this.querenChukuForm.plateNumber = ''
      this.querenChukuForm.zhuangcheCost = ''
      this.$nextTick(() => {
        this.$refs.querenChukuFormData.clearValidate()
      })

      this.querenChukuForm.plateNumber = this.xuanzhongArr.outstockPlateNumber
    },
    // 中远2.0-有装车费
    queRenChuku4 () {
      this.zyFlag = 1
      if (this.chukuTableData.length == 0) {
        DonMessage.error('暂无数据')
        return
      }
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
        return
      }
      if (this.xuanzhongArr.carHoldFalg == '1') {
        DonMessage.error('请先放行车辆')
        return
      }
      this.queRenChukuVisible = true
      this.querenChukuLoading = false
      this.querenChukuForm.plateNumber = ''
      this.querenChukuForm.zhuangcheCost = ''
      this.$nextTick(() => {
        this.$refs.querenChukuFormData.clearValidate()
      })

      this.querenChukuForm.plateNumber = this.xuanzhongArr.outstockPlateNumber
    },
    // 中远2.0-有装车费
    queRenChuku5 () {
      if (this.chukuTableData.length == 0) {
        DonMessage.error('暂无数据')
        return
      }
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
        return
      }
      if (this.xuanzhongArr.carHoldFalg == '1') {
        DonMessage.error('请先放行车辆')
        return
      }
      this.queRenChuKuVisible1 = true
    },
    // 中远2.0-无装车费
    queRenChuku3 () {
      if (this.chukuTableData.length == 0) {
        DonMessage.error('暂无数据')
        return
      }
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
        return
      }
      if (this.xuanzhongArr.carHoldFalg == '1') {
        DonMessage.error('请先放行车辆')
        return
      }
      const that = this
      this.$confirm('确定出库吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        confirmWhOutstockZy({
          outstockId: this.xuanzhongArr.outstockId
        })
          .then(res => {
            DonMessage.success('出库成功')
            that.getOutstockMasterLists()
          })
          .catch(err => {
            this.$message.error(err.message)
          })
      })
    },
    queRenChuku1 () {
      if (this.chukuTableData.length == 0) {
        DonMessage.error('暂无数据')
        return
      }
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
        return
      }
      if (this.xuanzhongArr.carHoldFalg == '1') {
        DonMessage.error('请先放行车辆')
        return
      }
      // this.queRenChukuVisible = true
      // this.querenChukuForm.plateNumber = ''
      // this.querenChukuForm.zhuangcheCost = ''
      // this.$nextTick(() => {
      //   this.$refs.querenChukuFormData.clearValidate()
      // })

      // this.querenChukuForm.plateNumber = this.xuanzhongArr.outstockPlateNumber

      const that = this
      this.$confirm('确定出库吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        confirmWhOutstockLwg({
          outstockId: this.xuanzhongArr.outstockId
        })
          .then(res => {
            DonMessage.success('出库成功')
            that.getOutstockMasterLists()
          })
          .catch(err => {
            this.$message.error(err.message)
          })
      })
    },
    getOutstockMasterLists () {
      getOutstockMasterList(
        this.formInline
      )
        .then(res => {
          console.log(res)
          this.chukuTableData = res.pageInfo.list
          this.total = res.pageInfo.total
          if (res.pageInfo.list.length > 0) {
            this.xuanzhongArr = res.pageInfo.list[0]
            this.$nextTick(() => {
              if (this.chukuTableData.length > 0) {
                this.$refs.table1.setCurrentRow(res.pageInfo.list[0])
              }
            })

            this.getOutstockSummaryLists()
          } else {
            this.subTableData = []
            this.xuanzhongArr = {}
            this.allWeight = 0
            this.allNumber = 0
            this.totalXQ = 0
          }
        })
        .catch(err => {
          DonMessage.error(err.message)
        })
    },
    // 点击表格
    guanLianClick (row) {
      this.xuanzhongArr = row
      if (this.xuanzhongArr.source != 0) {
        DonMessage.error('数据来源必须是手动!')
        return
      }
      this.addProductTypeMark = true

      this.GuanlianHuowuRow = row
    },
    // 点击表格
    guanLianClickTwo (row) {
      this.xuanzhongArr = row
      if (this.xuanzhongArr.source != 0) {
        DonMessage.error('数据来源必须是手动!')
        return
      }
      this.addProductTypeTwoMark = true

      this.GuanlianHuowuRow = row
    },
    // 点击表格
    guanLianClickTwo1 (row) {
      this.xuanzhongArr = row
      if (this.xuanzhongArr.source != 0) {
        DonMessage.error('数据来源必须是手动!')
        return
      }
      this.addProductTypeThreeMark = true

      this.GuanlianHuowuRow = row
    },
    // 点击选中需要修改的行
    dianjixuanzhong (row) {
      console.log(row)
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
      this.getOutstockSummaryLists()
    },
    // 明细
    getOutstockSummaryLists () {
      getOutstockSummaryList({
        pageNo: this.currentXQ,
        pageSize: this.pagesizeXQ,
        outstockId: this.xuanzhongArr.outstockId
      })
        .then(res => {
          console.log(res)
          this.subTableData = res.pageInfo.list
          if (res.pageInfo.list.length > 0) {
            this.xuanzhongArrXQ = res.pageInfo.list[0]
            this.$nextTick(() => {
              if (this.subTableData.length > 0) {
                this.$refs.table2.setCurrentRow(res.pageInfo.list[0])
              }
            })
          }

          this.totalXQ = res.pageInfo.total
          this.allNumber = res.all.allNumber
          this.allWeight = res.all.allWeight
        })
        .catch(err => {
          DonMessage.error(err)
        })
    },
    deleteDetail () {
      if (this.subTableData.length == 0) {
        DonMessage.error('暂无数据')
        return
      }
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
        return
      }
      const that = this
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delTOutstockSummary({
          outstockSummaryId: this.xuanzhongArrXQ.outstockSummaryId
        })
          .then(res => {
            DonMessage.success('删除成功')
            that.getOutstockSummaryLists()
          })
          .catch(error => {
            DonMessage.error(error.message)
          })
      })
    },
    zhuangche () {
      if (this.subTableData.length == 0) {
        DonMessage.error('暂无数据')
        return
      }
      this.zhuangcheDialog = true
      this.zhuangcheLoading = false
      this.zhuangcheTitle = '装车确认'
      this.getUsersByTenantCodes()
      this.getWeighingMethodLists(this.xuanzhongArrXQ.productType)
      // if (this.xuanzhongArr.productType != 4) {
      //   this.zhuangcheRules.weighingWeight[0].required = false
      //   this.zhuangcheRules.weighingDate[0].required = false
      // } else {
      //   this.zhuangcheRules.weighingWeight[0].required = true
      //   this.zhuangcheRules.weighingDate[0].required = true
      // }

      getTOutstockSummary({
        outstockSummaryId: this.xuanzhongArrXQ.outstockSummaryId
      })
        .then(res => {
          console.log(res)
          this.singletonWeight = res.singletonWeight
          this.zhuangcheForm.sceneUserId = res.sceneUserId == null ? '' : res.sceneUserId
          this.zhuangcheForm.number = res.number
          this.zhuangcheForm.weight = res.weight
          // this.zhuangcheForm.weighingWeight = res.weighingWeight == null ? '' : res.weighingWeight
          // this.zhuangcheForm.weighingDate = res.weighingDate == null ? new Date() : res.weighingDate
        })
        .catch(err => {
          DonMessage.error(err)
        })
    },

    dianjiXiangqingtable (row) {
      // console.log(row)
      this.xuanzhongArrXQ = {}
      this.xuanzhongArrXQ = row
    },
    selectXiangqingTable () {},
    changeFun () {},
    // 分页
    handleCurrentChangeA (val) {
      this.formInline.pageNo = val
      this.getOutstockMasterLists()
    },
    handleSizeChangeA (val) {
      this.formInline.pageSize = val
      this.getOutstockMasterLists()
    },
    handleCurrentChangeXQ (val) {
      this.currentXQ = val
      this.getOutstockSummaryLists()
    },
    handleSizeChangeXQ (val) {
      this.pagesizeXQ = val
      this.getOutstockSummaryLists()
    },
    // dialogs
    // 装车
    zhuangcheClose () {
      this.zhuangcheDialog = false
      this.$refs.zhuangcheForm.resetFields()
      this.zhuangcheForm.sceneUserId = ''
      this.zhuangcheForm.weight = ''
      this.zhuangcheForm.number = ''
    },
    zhuangcheOK () {
      this.xianchangRY.forEach(item => {
        if (item.userCode == this.zhuangcheForm.sceneUserId) {
          this.zhuangcheForm.sceneUser = item.userName
        }
      })

      this.zhuangcheForm.outstockId = this.xuanzhongArrXQ.outstockId
      this.zhuangcheForm.outstockSummaryId = this.xuanzhongArrXQ.outstockSummaryId
      this.zhuangcheForm.warehouseId = this.xuanzhongArrXQ.warehouseId
      this.zhuangcheForm.warehouseName = this.xuanzhongArrXQ.warehouseName
      this.$refs.zhuangcheForm.validate((valid) => {
        if (valid) {
          this.zhuangcheLoading = true
          updateTOutstockSummary(this.zhuangcheForm)
            .then(res => {
              console.log(res)
              DonMessage.success('成功')
              this.zhuangcheDialog = false
              this.getOutstockSummaryLists()
            })
            .catch((err) => {
              this.zhuangcheLoading = false
              this.$message({
                message: err.message,
                type: 'error'
              })
            })
        } else {
          return false
        }
      })
    },
    // 净重
    planClose () {
      this.planDialog = false
      // this.$refs.planForm.resetFields()
    },
    planOK () {
      this.$refs.planForm.validate((valid) => {
        if (valid) {
          this.PlanOkLoading = true
          // this.planForm.ownerCustomerName = ''
          // this.planForm.productTypeName = this.huowuData.filter(item => item.item_no == this.planForm.productType)[0].show_name
          this.planForm.primaryCustomerName = this.OwnerData.filter(item => item.taxpayerNumber == this.planForm
            .primaryCustomerTaxId)[0].custerName
          this.planForm.customerName = this.OwnerData.filter(item => item.taxpayerNumber == this.planForm
            .customerTaxId)[0].custerName
          // this.OwnerData.forEach((item, index) => {
          //   if (item.taxpayerNumber == this.planForm.ownerCustomerTaxId) {
          //     this.planForm.ownerCustomerName = item.custerName
          //   }
          // })
          console.log(this.planForm.outstockId)
          if (!this.xinzeng) {
            updateWhOutstockMasterLwg({ ...this.planForm, outstockStatus: '0' })
              .then(res => {
                console.log(res)
                DonMessage.success('成功')
                this.getOutstockMasterLists()
                this.planDialog = false
              })
              .catch(err => {
                this.PlanOkLoading = false

                DonMessage.error(err)
              })
          } else {
            addWhOutstockMaster(this.planForm)
              .then(res => {
                console.log(res)
                DonMessage.success('成功')
                this.getOutstockMasterLists()
                this.planDialog = false
              })
              .catch(err => {
                this.PlanOkLoading = false

                DonMessage.error(err)
              })
          }
        } else {
          return false
        }
      })
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer()
        .then((res) => {
          this.OwnerData = res
          this.HQData = JSON.parse(JSON.stringify(res))
          this.HQData.unshift({
            'custerName': '无货权方',
            'taxpayerNumber': '-1'
          })
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
      zidian({
        groupNo: 'thread_product_type'
      })
        .then((res) => {
          this.huowuData = res
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getUsersByTenantCodes () {
      getUsersByTenantCode()
        .then(res => {
          // console.log(res)
          this.xianchangRY = res
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 获取货物计重方式
    getWeighingMethodLists (productType) {
      getWeighingMethodList({
        productType
      })
        .then(res => {
          console.log(res)
          this.outWeighingMethod = res[0].outWeighingMethod
          if (res[0].outWeighingMethod == 2) {
            this.zhuangcheRules.weighingWeight[0].required = true
            this.zhuangcheRules.weighingDate[0].required = true
            this.WhzhuangcheRules.weighingWeight[0].required = true
            this.WhzhuangcheRules.weighingDate[0].required = true
          } else {
            this.zhuangcheRules.weighingWeight[0].required = false
            this.zhuangcheRules.weighingDate[0].required = false
            this.WhzhuangcheRules.weighingWeight[0].required = false
            this.WhzhuangcheRules.weighingDate[0].required = false
          }
        })
        .catch(err => {
          DonMessage.error(err.message)
        })
    },

    // getDictionaryLists () {
    //   getDictionaryList({ tenantCode: window.localStorage.getItem('tenantCode'), groupNo: 'out_empty_remark' })
    //     .then(res => {
    //       console.log(res)
    //       this.planForm.remark = res[0].remark
    //     })
    //     .catch(err => {
    //       this.message({ message: err.message, type: 'error' })
    //     })
    // }
    WhzhuangcheClose () {
      this.WhzhuangcheDialog = false
      this.$refs.WhzhuangcheForm.resetFields()
      this.WhzhuangcheForm.sceneUserId = ''
      this.WhzhuangcheForm.weight = ''
      this.WhzhuangcheForm.number = ''
      this.WhzhuangcheForm.warehouseId = ''
    },
    zhuangcheMarkClose () {
      this.zhuangcheMark = false
      this.$refs.WhzhuangcheForm.resetFields()
      this.WhzhuangcheForm.sceneUserId = ''
      this.WhzhuangcheForm.weight = ''
      this.WhzhuangcheForm.number = ''
      this.WhzhuangcheForm.warehouseId = ''
    },
    WhzhuangcheOK () {
      this.xianchangRY.forEach(item => {
        if (item.userCode == this.zhuangcheForm.sceneUserId) {
          this.WhzhuangcheForm.sceneUser = item.userName
        }
      })
      this.CangweiOptions.forEach(item => {
        if (item.id == this.WhzhuangcheForm.warehouseId) {
          this.WhzhuangcheForm.warehouseName = item.value
        }
      })
      this.WhzhuangcheForm.outstockId = this.xuanzhongArrXQ.outstockId
      this.WhzhuangcheForm.outstockSummaryId = this.xuanzhongArrXQ.outstockSummaryId
      // 判断仓库是否改变，如果改变需要校验件数与库存可提件数，如果仓位没有变，不需要校验库存可提件数
      if (this.WhzhuangcheForm.warehouseId == this.xuanzhongArrXQ.warehouseId) {
        this.isValid = false
      } else {
        this.isValid = true
      }
      this.$refs.WhzhuangcheForm.validate((valid) => {
        if (valid) {
          this.WhzhuangcheLoading = true
          console.log(this.WhzhuangcheForm)

          if (this.isValid && this.WhzhuangcheForm.number > this.stockAvailableNumber) {
            this.$message({
              message: '实出件数不能大于库存可提件数',
              type: 'error'
            })
            this.WhzhuangcheLoading = false
            return
          }
          updateTOutstockSummary(this.WhzhuangcheForm)
            .then(res => {
              console.log(res)
              DonMessage.success('成功')
              this.WhzhuangcheDialog = false
              this.getOutstockSummaryLists()
            })
            .catch((err) => {
              this.WhzhuangcheLoading = false
              this.$message({
                message: err.message,
                type: 'error'
              })
            })
        } else {
          return false
        }
      })
    },
    Whzhuangche () {
      if (this.subTableData.length == 0) {
        DonMessage.error('暂无数据')
        return
      }
      this.WhzhuangcheDialog = true
      this.WhzhuangcheLoading = false
      this.isValid = false
      this.zhuangcheTitle = '装车确认'
      this.getUsersByTenantCodes()
      this.getWeighingMethodLists(this.xuanzhongArrXQ.productType)
      getPlgxTStockSummaryGroup({
        primaryCustomerTaxId: this.xuanzhongArr.primaryCustomerTaxId,
        customerTaxId: this.xuanzhongArr.customerTaxId,
        productType: this.xuanzhongArrXQ.productType,
        steelMillName: this.xuanzhongArrXQ.placeOfOrigin,
        model: this.xuanzhongArrXQ.model,
        specification: this.xuanzhongArrXQ.specification
      })
        .then(res => {
          let wareHouses = []
          res.forEach(item => {
            let objVal = {}
            objVal.id = item.warehouseId
            objVal.value = item.warehouseName
            wareHouses.push(objVal)
          })
          console.log(wareHouses)
          this.CangweiOptions = Array.from(new Set(wareHouses))
        })
        .catch(err => {
          DonMessage.error(err)
        })
        // if (this.xuanzhongArr.productType != 4) {
        //   this.zhuangcheRules.weighingWeight[0].required = false
        //   this.zhuangcheRules.weighingDate[0].required = false
        // } else {
        //   this.zhuangcheRules.weighingWeight[0].required = true
        //   this.zhuangcheRules.weighingDate[0].required = true
        // }

      getTOutstockSummary({
        outstockSummaryId: this.xuanzhongArrXQ.outstockSummaryId
      })
        .then(res => {
          console.log(res)
          this.singletonWeight = res.singletonWeight
          this.WhzhuangcheForm.sceneUserId = res.sceneUserId == null ? '' : res.sceneUserId
          this.WhzhuangcheForm.number = res.number
          this.WhzhuangcheForm.weight = res.weight
          this.WhzhuangcheForm.warehouseId = res.warehouseId
          // this.zhuangcheForm.weighingWeight = res.weighingWeight == null ? '' : res.weighingWeight
          // this.zhuangcheForm.weighingDate = res.weighingDate == null ? new Date() : res.weighingDate
        })
        .catch(err => {
          DonMessage.error(err)
        })
    },
    WhNumberInput () {
      this.WhzhuangcheForm.weight = (this.WhzhuangcheForm.number / 1 * this.singletonWeight / 1).toFixed(3)
    },
    changeCangWei (val) {
      this.stockAvailableNumber = ''
      if (val == '' || val == this.xuanzhongArrXQ.warehouseId) {
        this.isValid = false
      } else {
        this.isValid = true
      }
      if (val != '') {
        getTStockSummaryAvailableNumber({
          primaryCustomerTaxId: this.xuanzhongArr.primaryCustomerTaxId,
          // ownerCustomerTaxId: this.xuanzhongArr.ownerCustomerTaxId,
          customerTaxId: this.xuanzhongArr.customerTaxId,
          productType: this.xuanzhongArrXQ.productType,
          steelMillName: this.xuanzhongArrXQ.placeOfOrigin,
          model: this.xuanzhongArrXQ.model,
          specification: this.xuanzhongArrXQ.specification,
          // placeOfOrigin: this.xuanzhongArrXQ.specification,
          warehouseId: val
        })
          .then(res => {
            console.log(res)
            this.stockAvailableNumber = res
          })
          .catch(err => {
            this.$message({
              message: err.message,
              type: 'error'
            })
          })
      }
    }

  }

}

</script>
<style lang="less" scoped>
  // .chuKuZuoyeWarp{
  //   padding-left:20px;
  // }

.detailsTitle{
  margin-bottom: 0;
}
/deep/.el-tabs__header{
  margin-bottom: 0;
}
.formItemBox{
  /deep/.el-form-item{
    width: 24%;
    margin-bottom: -6px!important;
  }
}
  .detailsTitle-sum {
    .num {
      color: rgb(224, 0, 32);
      margin-right: 10px;
    }
  }

</style>
